import { useAuth } from '@agentnet/auth';
import { pxToRem } from '@fluentsms/agentnet-web-components';
import { Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Restore } from '@material-ui/icons';
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined';
import MailOutlineOutlinedIcon from '@material-ui/icons/EmailOutlined';
import { postUserActivationEmail } from 'api/manageUsers/manage-users-api';
import { UserRoleTypeNames } from 'features/admin/constants';
import { useState } from 'react';
import { AgentNetConfirmationDialog } from 'ui-kit/components/modal/ConfirmationDialog';
import useSnackBars from 'ui-kit/components/notification/useSnackbars';
import ViewHistory from './ViewHistory';
import { useNavPermissions } from 'hooks/useNavPermissions';

const useStyles = makeStyles({
  tooltip: {
    backgroundColor: '#fff',
    color: ' #423d3d',
    fontSize: pxToRem(13),
    padding: pxToRem(5),
    whiteSpace: 'nowrap',
    border: '1px solid lightgrey',
  },
  root: {
    width: '100%',
    marginTop: pxToRem(114),
  },
});

type UserActionsRendererProps = {
  userRoleType?: string;
  userStatus?: string;
  userId?: number;
  userEmail?: string;
  handleEditClick?: () => void;
};

const UserActionsRenderer = ({
  userRoleType,
  userStatus,
  userId,
  userEmail,
  handleEditClick,
}: UserActionsRendererProps) => {
  const classes = useStyles(); // Declare the 'classes' variable
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [sendEmail, setSendEmail] = useState(false);
  const [OpenModelFirm, setOpenModelFirm] = useState(false);
  const { getAccessToken } = useAuth();
  const { addSnackbarMessage } = useSnackBars();
  const { hasPermission } = useNavPermissions();
  const canEditUser = !hasPermission?.staffAdmin || userRoleType === UserRoleTypeNames.Staff;

  const handleDrawerOpen = () => {
    setDrawerOpen(drawerOpen);
  };
  const dismissSendActivationEmail = () => {
    setOpenModelFirm(false);
  };

  const sendActivationEmail = async () => {
    const token = await getAccessToken();
    const responsedata = await postUserActivationEmail(token, userId);
    if (responsedata) {
      addSnackbarMessage({
        message: 'Activation Email Successfully Sent',
        type: 'success',
      });
    } else {
      addSnackbarMessage({
        message: 'Email Could Not Be Sent. Try Again Later!',
        type: 'error',
      });
    }
    setOpenModelFirm(false);
    setSendEmail(false);
  };
  const dialogText = `Account information and login credential will be sent to ${userEmail}. Do you want to proceed?`;
  const mailIcon =
    userStatus === 'Not Activated' && userRoleType === 'Agent' && !hasPermission?.orderManagementAdmin ? (
      <Tooltip title="Send Account Information" classes={{ tooltip: classes.tooltip }}>
        <MailOutlineOutlinedIcon
          fontSize="small"
          htmlColor="#0074CA"
          onClick={() => {
            setSendEmail(true);
            setOpenModelFirm(true);
          }}
        />
      </Tooltip>
    ) : null;

  const handleEdit = () => {
    handleEditClick && handleEditClick();
  };

  return (
    <span>
      <div className="iconContainer">{mailIcon}</div>
      {!hasPermission?.orderManagementAdmin && (
        <div className="iconContainer">
          <Tooltip title="History" classes={{ tooltip: classes.tooltip }}>
            <div>
              <Restore
                fontSize="small"
                htmlColor="#0074CA"
                onClick={() => {
                  setDrawerOpen(true);
                }}
              />
            </div>
          </Tooltip>
        </div>
      )}
      {canEditUser && (
        <div className="iconContainer">
          <Tooltip title="Edit User" classes={{ tooltip: classes.tooltip }}>
            <CreateOutlinedIcon fontSize="small" htmlColor="#0074CA" onClick={() => handleEdit()} />
          </Tooltip>
        </div>
      )}
      {drawerOpen ? (
        <ViewHistory userId={userId} handleDrawerOpen={drawerOpen} closeDrawer={() => setDrawerOpen(false)} />
      ) : null}
      {sendEmail && (
        <AgentNetConfirmationDialog
          qaAttrPrefix="ConfirmationCancel"
          onConfirm={sendActivationEmail}
          open={OpenModelFirm}
          onDismissAction={dismissSendActivationEmail}
          dialogTitle="Resend Activation Email"
          dialogBtnContent="Yes"
          secondaryActionBtnContent="No"
          dialogText={dialogText}
        />
      )}
    </span>
  );
};

export default UserActionsRenderer;
